module.exports = __webpack_public_path__ + "static/media/3_1_CAM.19fa20f3.png";